import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import Seo from "../components/Seo";

import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";

import FullWidthImage from "../components/FullWidthImage";
import DisplayContentHeader from "../components/DisplayContentHeader";
import Summary from "../components/Summary";
import MapsList from "../components/MapsList";
import MapsMenuList from "../components/MapsMenuList";

// eslint-disable-next-line
export const MapPageTemplate = ({
  title,
  subtitle,
  image,
  meta,
  summary,
  body,
  helmet,
}) => {
  const PageContent = HTMLContent || Content;
  const heroImage = getImage(image) || image;

  const showTitle = meta.showTitle;

  return (
    <div>
      {helmet || null}
      {showTitle ? (
        <FullWidthImage
          img={heroImage}
          title={title}
          subheading={subtitle}
          imgPosition="center"
        />
      ) : (
        <FullWidthImage img={heroImage} imgPosition="center" />
      )}

      <section className="section section--gradient">
        <div className="container">
          <div className="content">
            <div className="content">
              {title === "Maps" ? (
                <DisplayContentHeader title={title} />
              ) : (
                <>
                  <DisplayContentHeader
                    title={title}
                    parent="Maps"
                    parentSlug="/maps"
                  />
                  <h4 className="mt-c">{subtitle}</h4>
                </>
              )}
            </div>
            <PageContent className="content" content={body} />

            {title !== "Maps" ? (
              <>
                <Summary summary={summary} />
              </>
            ) : (
              <>
                <MapsMenuList />
                <h2>All Maps</h2>
                <MapsList />
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

MapPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.shape({
    showTitle: PropTypes.bool,
  }),
  summary: PropTypes.string,
  body: PropTypes.string,
  helmet: PropTypes.object,
};

const MapPage = ({ data }) => {
  const { markdownRemark: post } = data;

  let imageSrc =
    post.frontmatter.image.childImageSharp.gatsbyImageData.images.fallback.src;

  return (
    <Layout>
      <MapPageTemplate
        title={post.frontmatter.title}
        subtitle={post.frontmatter.subtitle}
        image={post.frontmatter.image}
        meta={post.frontmatter.meta}
        summary={post.frontmatter.summary}
        body={post.html}
        helmet={
          <Seo
            title={post.frontmatter.title}
            summary={post.frontmatter.summary}
            image={imageSrc}
            article={false}
            keywords={[
              `${post.frontmatter.title} Map`,
              `${post.frontmatter.title} ${post.frontmatter.subtitle}`.replace(
                "Moab, Utah ",
                ""
              ),
              `${post.frontmatter.title} ${post.frontmatter.subtitle}`,
              "moab trail map",
              "moab utah trail map",
              "trail map",
              "map",
            ]}
          />
        }
      />
    </Layout>
  );
};

MapPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default MapPage;

export const mapPageQuery = graphql`
  query MapPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        subtitle
        image {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
          }
        }
        meta {
          showTitle
        }
        summary
      }
    }
  }
`;
